import request from "../utils/http"

export function pageList(params) {
  return request({
    url: '/page/list',
    method: 'get',
    params
  })
}

export function pageSave(data) {
  return request({
    url: '/page/save',
    method: 'post',
    data
  })
}

export function pageInfo(params) {
  return request({
    url: '/page/info',
    method: 'get',
    params
  })
}

export function pageDelete(data) {
  return request({
    url: '/page/delete',
    method: 'post',
    data
  })
}

export function getUploadToken() {
  return request({
    url: 'getUploadToken',
    method: 'get'
  })
}

export function getPhoneCode(data) {
  return request({
    url: '/noahapi/v5/king/common/send_phone_code',
    method: 'post',
    data
  })
}

export function traceLog(data) {
  return request({
    url: '/reserve/save',
    method: 'post',
    data
  })
}
export function traceKyc(data) {
  return request({
    url: '/reserve/saveKyc',
    method: 'post',
    data
  })
}

export function getAreaList(params) {
  return request({
    url: '/getAreaList',
    method: 'get',
    params
  })
}

export function getAccountInfo(data) {
  return request({
    url: '/queryInfo',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js